export default class SettingsViewModel {
    public partTimeFactor: boolean = false;
    public includeGFANotInUse: boolean = false;
}